import { handleActions } from 'redux-actions';

import { setEditPermisionAutotieout } from 'store/actions/edit-permision-actions';
import EditPermission from 'models/data/edit-permision-model';

export default handleActions(
  {
    [setEditPermisionAutotieout]: (editPermision, { payload }) => {
      return editPermision.setEditPermissionAutotieout(payload);
    },
  },
  new EditPermission(),
);
